import 'rxjs/add/operator/race';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/concatMap';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/debounceTime';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { entitiesMetaData } from '../metaData';
import { sdkPromise } from '../../../../utils/sdk';
import { handleError, handleSuccess } from '../handleResult';
import { getCurrentEntity, getSelectedEntityId, getSelectedEntity } from '../selectors';
import { setSelectedSubEntityId } from '../index';

import { addToPendingSubmit, setTermsForm } from './actions';
import { getPendingSubmit, selectTypes } from './selectors';
import { generateUUID } from 'serenova-js-utils/uuid';

export const HandleTermsFormSubmit = ($action, store) =>
  $action
    .ofType('TERMS_FORM_SUBMIT1')
    .mergeMap(action => {
      const pendingSubmit = getPendingSubmit(store.getState());
      return [
        {
          type: 'CREATE_ENTITY',
          entityName: 'amr',
          values: pendingSubmit.toJS()
        }]
    });

export const CreateEntity = ($action, store) =>
  $action
    .ofType('CREATE_ENTITY')
    .filter(action => action.entityName === 'amr')
    .mergeMap(action => {
    store.getState().setIn(["form", ''], true);
    const { values, entityName } = action; 
      const artifactTypes = selectTypes(store.getState());
      const matchedArtifactType = artifactTypes
        ? artifactTypes.find(({ artifactType }) => artifactType === values.artifactType)
        : [];

        let value=values.toJSON();
        // if(value.requestedArtifactSubType == "null"){
        //   delete value.requestedArtifactSubType;
        // }
        if(value.requestType=="add-lock"){
        delete value.removeLock;
          if (value.lockExpiryDate == undefined) {
            value.lockExpiryDate = new Date().toISOString().split('T')[0];
          } else {
            value.lockExpiryDate = new Date(value.lockExpiryDate).toISOString().split('T')[0];
          }
        }else if(value.requestType=="remove-lock"){
          delete value.lockExpires;
          delete value.lockExpiryDate;
          delete value.removeLock;
        }else if(value.requestType=="delete"){
          delete value.lockExpires;
          delete value.lockExpiryDate;
        }

      let properties={};
      for (const key in value) {
        if (value.hasOwnProperty(key)) { 
            properties[key]=value[key]
        }
      }
      const interactionIdArray=value.interactionIds.split(",");
      delete properties.interactionIds;
     
      const actionList= interactionIdArray.map(interactionId => {
        return {
          properties,
          interactions:interactionId,
          type: 'CREATE_INTERACTION_ID',
          interactionIdCount: interactionIdArray.length
        }
      })
      return actionList;

    })

export const CreateInteractionId = ($action, store) =>
  $action
    .ofType('CREATE_INTERACTION_ID')
    .map((action) => ({
      ...action,
      entityName: getCurrentEntity(store.getState())
    }))
    .map((a) => {
      const {properties,interactions,interactionIdCount} =a;
      window.parent.postMessage('start', '*');
      a.interactionIdCount = interactionIdCount;
      a.sdkCall = {
        module: 'entities',
        data:{ properties,
              interactions:interactions},
        command: 'createAmr',
        topic: 'cxengage/entities/create-amr-response',
        crudAction: 'create',
        apiVersion: entitiesMetaData[a.entityName].sdkCall.apiVersion 
      };
      return { ...a };
    })
    .concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => ({
          type: 'FETCH_AMR_REQUEST_FULFILLED',
          viewData: response.result,
          interactionIdCount:action.interactionIdCount
        }))
        .catch(error => handleError(error, action))
    );

export const FetchArtifactTypesAfterALPs = ($action, store) =>
  $action
    .ofType('FETCH_DATA_FULFILLED','FETCH_DATA_REJECTED')
    .filter(a => a.entityName === 'alps' || a.entityName === 'amr')
    .map((action) => ({
      ...action,
      selectedEntityId: getSelectedEntityId(store.getState()),
      sdkCall: {
        apiVersion: 'v1',
        command: 'getAlpTypes',
        crudAction: 'read',
        module: "entities",
        path: ['artifact-policies'],
        topic: 'cxengage/entities/get-alp-types-response',
      }
    }))
    .concatMap(action =>
      {return fromPromise(sdkPromise(action.sdkCall))
        .map(response => ({
          type: 'FETCH_ARTIFACT_TYPES_FULFILLED',
          artifactTypes: response.result,
          entityType:action.entityName
        }))
        .catch(error => handleError(error, action))}
    );
    export const FetchRequestTypesAfterALPs = ($action, store) =>
    $action
      .ofType('FETCH_DATA_FULFILLED','FETCH_DATA_REJECTED')
      .filter(a=> a.entityName === 'amr')
      .map((action) => ({
        ...action,
        selectedEntityId: getSelectedEntityId(store.getState()),
        sdkCall: {
          apiVersion: 'v1',
          command: 'getAmrRequest',
          crudAction: 'read',
          module: "entities",
          path: ['manage-artifact-request'],
         topic: 'cxengage/entities/get-amr-request-types',
        }
      }))
      .concatMap(action =>
        fromPromise(sdkPromise(action.sdkCall))
          .map(response => ({
            // todo: maybe use handleSuccess here?
            type: 'FETCH_AMR_REQUEST_TYPES_FULFILLED',
            requestType: response.result,
          }))
          .catch(error => handleError(error, action))
      );

export const UpdateEntity = ($action, store) =>
  $action
    .ofType('UPDATE_ENTITY')
    .filter(({ entityName }) => entityName === 'alps')
    .map((action) => {
      return {
        ...action,
        sdkCall: {
          apiVersion: 'v1',
          command: 'updateAlp',
          crudAction: 'update',
          data: {
            alpId: action.values && action.values.activeVersion,
            updateBody: action.values
          },
          module: "entities",
          path: ['artifact-policies'],
          topic: 'cxengage/entities/update-alp-response',
        }
      };
    })
    .concatMap(action =>
      fromPromise(sdkPromise(action.sdkCall))
        .map(response => handleSuccess(response, action, 'Artifact Lifecycle Policy was updated successfully!'))
        .catch(error => handleError(error, action))
    );

    export const deleteSubmittedValues = ($action, store) =>
  $action
    .ofType('SET_SELECTED_ENTITY_ID')
    .filter(({ entityId }) => entityId=="create")
    .map((a) => {
      return {
        type: 'DELETE_ENTITY_AMR',
        entityName:'amr'
      };
    });

    export const fetchDataAMR = ($action, store) =>
    $action
      .ofType('FETCH_DATA_AMR')
      .filter(({ entityName }) => entityName === 'amr')
      .map((action) => {
        return {
          ...action,
          sdkCall: {
            apiVersion: 'v1',
            command: 'getAmr',
            crudAction: 'read',
            module: "entities",
            path: ['manage-artifact-request'],
           topic: 'cxengage/entities/get-amr-response',
          }
        };
      })
      .concatMap(action =>
        fromPromise(sdkPromise(action.sdkCall))
          .map(response => ({
            type: 'FETCH_DATA_AMR_FULFILLED',
            requestId: action.requestId,
            entityType:'amr',
            response:response
          }))
          .catch(error => handleError(error, action))
      );
